import { createRouter, createWebHistory } from 'vue-router';
import SessionView from '@/views/app/session/SessionView.vue';
import { generateRoomCode } from '@/services/room.service.ts';
import { useAuthStore } from '@/stores/auth.ts';

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: () => {
                // This page is not ready, so redirect to the session page
                return { name: `session` };
            },
            // component: HomeView,
        },
        {
            path: '/auth',
            name: 'auth',
            component: () => import('@/views/auth/_AuthLayout.vue'),
            beforeEnter: (_, __, next) => {
                const auth = useAuthStore();
                if (!auth.isAuthenticated) {
                    next();
                } else {
                    next({ name: 'dashboard' });
                }
            },
            children: [
                {
                    path: 'login',
                    name: 'login',
                    component: () => import('../views/auth/login/LoginView.vue'),
                },
                {
                    path: 'login/password',
                    name: 'login-with-password',
                    component: () => import('../views/auth/login/LoginWithPasswordView.vue'),
                },
                {
                    path: 'signup',
                    name: 'signup',
                    component: () => import('../views/auth/signup/SignupView.vue'),
                },
                {
                    path: 'verify-email',
                    name: 'verify-email',
                    component: () => import('../views/auth/VerifyEmailView.vue'),
                },
                {
                    path: 'request-password-reset',
                    name: 'request-password-reset',
                    component: () => import('../views/auth/password-reset/PasswordResetRequestView.vue'),
                },
                {
                    path: 'reset-password',
                    name: 'reset-password',
                    component: () => import('../views/auth/password-reset/PasswordResetView.vue'),
                },
                {
                    path: 'legal/accept',
                    name: 'legal-acceptance',
                    component: () => import('../views/auth/legal/LegalAcceptView.vue'),
                },
            ],
        },
        {
            path: '/',
            component: () => import('@/views/app/session/_Layout.vue'),
            meta: {
                requiresAuth: true,
            },
            children: [
                {
                    path: 'dashboard',
                    name: 'dashboard',
                    redirect: () => {
                        // This page is not ready, so redirect to the session page
                        return { name: `session` };
                    },
                    // component: () => import('@/views/app/DashboardView.vue'),
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'session',
                    name: 'session',
                    redirect: () => {
                        const room = generateRoomCode();
                        return { path: `/session/${room}` };
                    },
                    meta: {
                        requiresAuth: true,
                    },
                },
                {
                    path: 'session/:room',
                    name: 'room',
                    component: SessionView,
                    meta: {
                        requiresAuth: true,
                    },
                },
            ],
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: () => import('../views/error/NotFoundView.vue'),
        },
    ],
});

router.beforeEach(async (to, _) => {
    const auth = useAuthStore();
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const isLegalAcceptanceRoute = to.name === 'legal-acceptance';

    await auth.ensureAuth();
    if (auth.status === 'legal_required' && !isLegalAcceptanceRoute) {
        return { name: 'legal-acceptance', query: { next: to.fullPath } };
    }
    if (requiresAuth && !auth.isAuthenticated) {
        return { name: 'login', query: { next: to.fullPath } };
    }
});

export default router;
